var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"organizations",attrs:{"id":"organizations"}},[_c('swiper',{attrs:{"options":_vm.swiperOption}},_vm._l((_vm.organizations),function(org){return _c('swiper-slide',{staticClass:"swiper-slide"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"img",style:({'background-image':'url(' + org.imagePath +')'})})])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }